import clsx from 'clsx'

/**
 * Horizontal peak meter. -60 dBFS..0 dBFS mapped to 0..100%.
 * Green below -12, amber to -6, red above (hot).
 */
export function LevelMeter({ db, className }: { db: number; className?: string }) {
  const pct = Math.max(0, Math.min(100, ((db + 60) / 60) * 100))
  const color = db > -6 ? 'var(--red)' : db > -12 ? 'var(--amber)' : 'var(--green)'
  return (
    <div
      data-testid="rt-level-meter"
      role="meter"
      aria-valuemin={-60}
      aria-valuemax={0}
      aria-valuenow={Math.round(Math.max(-60, db))}
      aria-label="Input level"
      className={clsx('h-2 w-full overflow-hidden rounded-full bg-[var(--bg-3)]', className)}
    >
      <div
        className="h-full rounded-full transition-[width] duration-75"
        style={{ width: `${pct}%`, background: color }}
      />
    </div>
  )
}
